import { PATHS } from "@/lib/router";
import {
  CreateSurveyPage,
  QuestionLibraryPage,
  TakeSurveyPage,
  SurveyLibraryPage,
  SurveyResponsesPage,
  ResponsesDetailPage,
} from "./pages";

export const surveyManagementRoutes = [
  {
    path: PATHS.SURVEY_LIBRARY,
    element: <SurveyLibraryPage />,
    handle: { permission: { resource: "survey_library", action: "view" } },
  },
  {
    path: PATHS.QUESTION_LIBRARY,
    element: <QuestionLibraryPage />,
    handle: { permission: { resource: "question_library", action: "view" } },
  },
  {
    path: PATHS.SURVEY_RESPONSES,
    element: <SurveyResponsesPage />,
    handle: { permission: { resource: "survey_responses", action: "view" } },
  },
  {
    path: PATHS.RESPONSES_DETAIL,
    element: <ResponsesDetailPage />,
    handle: { permission: { resource: "survey_responses", action: "view" } },
  },
  {
    path: PATHS.CREATE_NEW_SURVEY,
    element: <CreateSurveyPage />,
    handle: { permission: { resource: "survey_library", action: "create" } },
  },
  {
    path: PATHS.EDIT_SURVEY,
    element: <CreateSurveyPage />,
    handle: { permission: { resource: "survey_library", action: "create" } },
  },
];

export const surveyLibraryPublicRoutes = [
  {
    path: PATHS.TAKE_SURVEY,
    element: <TakeSurveyPage />,
  },
];
